import Vue from "vue";
import App from "./App.vue";

// PC端
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/common.css';

// 移动端
import Vant from "vant";
import "vant/lib/index.css";
import router from "./router";
import store from "./store";

Vue.use(Vant);
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
